import planner_icon from "../assets/images/navigation_icons/planner.svg";
import tenants_icon from "../assets/images/navigation_icons/tenant.svg";
import invite_icon from "../assets/images/navigation_icons/invite_codes.svg";
import explore_icon from "../assets/images/navigation_icons/explore.svg";
import students_icon from "../assets/images/navigation_icons/students.svg";
import schools_icon from "../assets/images/navigation_icons/schools.png";
import teams_icon from "../assets/images/navigation_icons/teams.svg";
import bulk_upload_jobs_icon from "../assets/images/navigation_icons/bulk_upload_jobs.svg";

export const navigationItems = [
  {
    icon: planner_icon,
    label: "Planner",
    path: "planner",
  },
  // {
  //   icon: tenants_icon,
  //   label: "Tenants",
  //   path: "tenants",
  // },
  {
    icon: invite_icon,
    label: "Invite Codes",
    path: "invite-codes",
  },
  {
    icon: explore_icon,
    label: "Explore",
    path: "explore",
  },
  {
    icon: students_icon,
    label: "Students",
    path: "students",
  },
  {
    icon: schools_icon,
    label: "Schools",
    path: "schools",
  },
  {
    icon: teams_icon,
    label: "Teams",
    path: "teams",
  },
  {
    icon: bulk_upload_jobs_icon,
    label: "Bulk Upload Jobs",
    path: "bulk-upload-jobs",
  },
];
